<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div id="workflow-process_execution" class="content">
                <!--                <em-workflow-process-execution :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey" :businessKey="$_emWorkflowTaskMixin_businessKey">-->
                <!--                </em-workflow-process-execution>-->
                <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                     :config="processConfig"
                                     ref="processExecution" @gotItems="setLocalVariables"
                                     :businessKey="$_emWorkflowTaskMixin_businessKey">
                </WorkflowProcessLine>
            </div>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <!--                <em-workflow-task-complete :taskId="$_emWorkflowTaskMixin_taskId"-->
                <!--                                           :callbackApi="$_emWorkflowTaskMixin_callbackApi"-->
                <!--                                           @taskCompleted="$_emWorkflowTaskMixin_handleTaskCompleted">-->
                <!--                </em-workflow-task-complete>-->
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="processConfig">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author thq
// Date 2024-03-28 10:48:22

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";

export default {
    name: "emMaMaintenanceWoWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        processConfig() {
            return {
                'task1': {
                    name: '执行中',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '提请验收'},
                                {value: 2, text: '作废工单'}
                            ]
                        }
                    ],
                    withAttachment: true,
                    withComment: true
                },
                'task2': {
                    name: '验收',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '验收通过'},
                                {value: 2, text: '验收不合格'}
                            ]
                        }
                    ],
                    withAttachment: true,
                    withComment: true
                },
                'task1_1': {
                    name: '重新执行中',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '提请验收'},
                                {value: 2, text: '作废工单'}
                            ]
                        }
                    ],
                    withAttachment: true,
                    withComment: true
                },
                '*': {
                    name: '设备定修',
                    variables: [
                        {
                            label: '提交类型',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '至下一任务'},
                                {value: 2, text: '驳回'}
                            ]
                        }
                    ],
                    withAttachment: true,
                    withComment: true
                }
            }
        }
    }
};
</script>